import { z } from "zod";
import { WebSdkSettings } from "./WebSdkSettings";

export const ZStreamInfo = z.object({
  type: z.literal("streamInfo"),
  streamInfo: z.object({
    guid: z.string(),
    autoPlay: z.boolean().optional(),
    touchCapable: z.boolean().optional(),
    resolution: z
      .object({
        width: z.number().int().nonnegative(),
        height: z.number().int().nonnegative(),
        dynamic: z.boolean().optional(),
        fixed: z.boolean().optional(),
      })
      .optional(),
    meta: z
      .object({
        friendlyName: z.string().optional(),
        isTrial: z.boolean().optional(),
        mouseLock: z.boolean().optional(),
        poweredBy: z.boolean().optional(),
        ueVersion: z.string().optional(),
        version: z.string().optional(),
      })
      .optional(),
    webSdkSettings: WebSdkSettings.optional(),
    afk: z
      .object(
        {
          enabled: z.boolean().describe("Enables / Disables AFK functionality."),
          warn: z
            .number()
            .int()
            .nonnegative()
            .describe("Time in seconds, after last interaction, when the first warning will be triggered."),
          error: z
            .number()
            .int()
            .nonnegative()
            .describe("Time in seconds, after warn trigger, when a more pushy warning will be triggered."),
          action: z
            .number()
            .int()
            .nonnegative()
            .describe("Time in seconds, after error trigger, the actual disconnection action will take place."),
        },
        {
          description:
            "AFK stands for 'away from keyboard' and describes a timeout based on activity of the actual project. All execution of these settings are prone to frontend and therefore no full security measure for abuse! These settings can be overwritten by shareId, but would overwrite the settings given through frontend configuration.",
        }
      )
      .optional(),
  }),
});
export type StreamInfo = z.infer<typeof ZStreamInfo>;
